import axios from "axios";

/**
 * Fetches the weather
 * 
 * @param {Object} props The requested parameters: lat, lon, and appid (apiKey)
 * @returns The weather at the requested location
 */
export const fetchWeather = async ({ latitude, longitude, apiKey }) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_BASE_URL_REST_API_WEATHER,
      {
        params: {
          lat: latitude,
          lon: longitude,
          appid: apiKey,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
};
